module.exports = __webpack_public_path__ + "img/report_image_3.20333b9d.png";